var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.5,
    height: 3.799,
    viewBox: "0 0 39.5 3.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.5)",
    opacity: 0.197
  }, /*#__PURE__*/React.createElement("line", {
    x2: 35.6,
    transform: "translate(29.5 1.95)",
    fill: "none",
    stroke: "#050f15",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9,3.9h0L0,0H3.8L1.9,3.9Z",
    transform: "translate(65.1 3.799) rotate(-90)",
    fill: "#050f15"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaCard);
export default __webpack_public_path__ + "static/media/flecha-card.c20c98d23e509f34b4e0f7e4b940967a.svg";
export { ForwardRef as ReactComponent };